import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import './Reports.css';

function formatDateDefault(daysAgo) {
  const d = new Date();
  d.setDate(d.getDate() - daysAgo);
  return d.toISOString().slice(0, 10);
}

function Reports({ currentUser }) {
  const [from, setFrom] = useState(formatDateDefault(30));
  const [to, setTo] = useState(formatDateDefault(0));
  const [track, setTrack] = useState('');
  const [trainer, setTrainer] = useState('');
  const [filterOptions, setFilterOptions] = useState({ trainers: [], tracks: [] });
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFilters = async () => {
      try {
        const resp = await api.get('/api/dogs/filters');
        setFilterOptions({
          trainers: resp.data?.trainers || [],
          tracks: (resp.data?.tracks || []).map((t) => t.name || t),
        });
      } catch (err) {
        console.error('Could not fetch filter options:', err);
      }
    };
    fetchFilters();
    runReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const runReport = async () => {
    setLoading(true);
    setError(null);
    try {
      const params = { from, to };
      if (track) params.track = track;
      if (trainer) params.trainer = trainer;
      const resp = await api.get('/api/reports/runs', { params });
      setReport(resp.data);
    } catch (err) {
      setError(err?.response?.data?.error || 'Could not load report');
      setReport(null);
    } finally {
      setLoading(false);
    }
  };

  const downloadCsv = async () => {
    try {
      const params = new URLSearchParams({ from, to });
      if (track) params.set('track', track);
      if (trainer) params.set('trainer', trainer);
      const resp = await api.get(`/api/reports/runs/export?${params.toString()}`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `runs_${from}_to_${to}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      alert(err?.response?.data?.error || 'Could not download CSV');
    }
  };

  return (
    <div className="reports-page">
      <h1>Reports</h1>
      <p className="reports-subtitle">Runs and unique dogs over a date range.</p>

      <div className="reports-filter-bar">
        <div className="reports-filter-row">
          <label>From:</label>
          <input type="date" value={from} onChange={(e) => setFrom(e.target.value)} />
          <label>To:</label>
          <input type="date" value={to} onChange={(e) => setTo(e.target.value)} />
          <label>Track:</label>
          <select value={track} onChange={(e) => setTrack(e.target.value)}>
            <option value="">All tracks</option>
            {filterOptions.tracks.map((t) => <option key={t} value={t}>{t}</option>)}
          </select>
          <label>Trainer:</label>
          <select value={trainer} onChange={(e) => setTrainer(e.target.value)}>
            <option value="">All trainers</option>
            {filterOptions.trainers.map((t) => <option key={t} value={t}>{t}</option>)}
          </select>
          <button type="button" onClick={runReport} disabled={loading}>
            {loading ? 'Loading...' : 'Apply'}
          </button>
        </div>
      </div>

      {error && <div className="reports-error">{error}</div>}

      {report && (
        <div className="reports-stats-grid">
          <div className="reports-stat-card">
            <div className="reports-stat-label">Total Runs</div>
            <div className="reports-stat-number">{report.total_runs}</div>
          </div>
          <div className="reports-stat-card">
            <div className="reports-stat-label">Unique Dogs</div>
            <div className="reports-stat-number">{report.unique_dogs}</div>
          </div>
        </div>
      )}

      <div className="reports-actions">
        <button type="button" className="reports-download-btn" onClick={downloadCsv}>
          Download CSV
        </button>
      </div>
    </div>
  );
}

export default Reports;
